import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AssetDiscussionItem {
  id: string;
  title: string;
  author: string;
  lastActivity: string;
  isPinned?: boolean;
  isBookmarked?: boolean;
}

@Component({
  selector: 'app-asset-discussion-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-discussion-list.component.html',
  styleUrl: './asset-discussion-list.component.scss',
})
export class AssetDiscussionListComponent {
  @Input() discussions: AssetDiscussionItem[] = [];
  @Input() assetTypeLabel = 'Dataset';
  /** When true, discussion items cannot be opened (e.g. pending/rejected assets). */
  @Input() interactionsDisabled = false;
  @Output() navigate = new EventEmitter<string>();

  onNavigate(discussionId: string, event?: Event): void {
    if (this.interactionsDisabled) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }
    event?.stopPropagation();
    this.navigate.emit(discussionId);
  }
}
